import Repository from './Repository'
const resource = '/shops'

export default {
  /**
   * 店舗一覧を取得する
   */
  async get() {
    return await Repository.get(`${resource}`)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
}
